import '@beyondtrust/btux-iconography-web';
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import urlJoin from 'url-join';
import { DirtyFormController } from '../../controllers/dirty-form-controller';
import { PMC_SLUG, ProductMenuItem } from '../../types';
import { styles } from './product-header-link.styles.scss';
export const PLATFORM_PRODUCT_HEADER_LINK = 'platform-product-header-link' as const;

/**
 * Component used to render the appropriate
 * product icon based on product slug.
 */
@customElement(PLATFORM_PRODUCT_HEADER_LINK)
export class PlatformProductHeaderLink extends LitElement {
  static override styles = [styles];

  @property({ type: Object })
  currentProduct!: ProductMenuItem;

  @property()
  activeRoute!: string;

  /** Deployment environment badge text (e.g. "Staging"/"Preview"); empty in production. */
  @property()
  environmentLabel = '';

  dirtyFormController: DirtyFormController = new DirtyFormController(this);

  override render() {
    return html`
      <section class="product-heading">
        <a
          href="${urlJoin(this.currentProduct.baseHref, this.currentProduct.slug === PMC_SLUG ? 'home' : '')}"
          aria-label=${this.currentProduct.name}
        >
          <platform-product-icon productSlug=${this.currentProduct.slug}></platform-product-icon>
        </a>
        <span class="product-heading-secondary-text"> ${this.activeRoute || this.currentProduct.name} </span>
        ${when(
          this.environmentLabel,
          () =>
            html`<span class="product-heading-secondary-text product-header-environment">
              ${this.environmentLabel}
            </span>`,
        )}
      </section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [PLATFORM_PRODUCT_HEADER_LINK]: PlatformProductHeaderLink;
  }
}
